import { styled } from 'linaria/lib/react';

export const StyledInputContainer = styled.div<{ hasPaddingBottom: boolean }>`
  padding: 32px 0 ${({ hasPaddingBottom }) => (hasPaddingBottom ? 96 : 32)}px;
  transition: padding 100ms ease-in-out;
`;
